import {
  SET_ADD_CARD_FORM_IS_LOADING,
  SET_IS_LOADING_PAYMENT_METHODS,
  SET_PAYMENT_METHODS,
  ADD_CARD_FORM_IS_SUBMITTING,
} from "redux/constants/portal";

const initialState = {
  addCardFormIsLoading: true,
  isLoadingPaymentMethods: false,
  paymentMethods: [],
  addCardFormIsSubmitting: false,
};

const customerBilling = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ADD_CARD_FORM_IS_LOADING:
      return {
        ...state,
        addCardFormIsLoading: payload,
      };
    case SET_IS_LOADING_PAYMENT_METHODS:
      return {
        ...state,
        isLoadingPaymentMethods: payload,
      };
    case SET_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: payload,
      };
    case ADD_CARD_FORM_IS_SUBMITTING:
      return {
        ...state,
        addCardFormIsSubmitting: payload,
      };
  }
  return state;
};

export default customerBilling;
